import { z } from "zod/v4";
import { fiscalYearResponseSchema } from "../../schemas/finance";
import { fetchApi } from "../client/internal";

export const fiscalYears = {
	list: (clubId: string) => fetchApi(`/${clubId}/years`, z.array(fiscalYearResponseSchema)),
	create: (clubId: string, data: unknown) =>
		fetchApi(`/${clubId}/years`, fiscalYearResponseSchema, {
			method: "POST",
			body: JSON.stringify(data),
		}),
	close: (clubId: string, yearId: string) =>
		fetchApi(`/${clubId}/years/${yearId}`, z.object({ closed: z.boolean() }), {
			method: "PATCH",
		}),
};
